import axios from 'axios'

const ProductService = {
  async get (params = {}) {
    return axios.get('admin/products', { params })
  },

  async import (params = {}) {
    return axios.post('admin/utilities/import-products', params)
  },

  async sync (params = {}) {
    return axios.post('admin/utilities/sync-products', params)
  },

  async post (params = {}) {
    return axios.post('admin/products', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/products/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/products/${data.id}`, { data })
  }
}

export default ProductService
